var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer mt-3 mb-3 text-muted"},[_c('small',[_vm._v("Copyright MXD LLC")])])
}]

export { render, staticRenderFns }